import React from 'react';
import { GroupBase, SelectComponentsConfig, ValueContainerProps, components as ReactSelectComponents } from 'react-select';
import useValueContainerStyles from '../useSelect/useValueContainerStyles';
import type { SelectSize } from '../interfaces';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  dataTest: string,
  isLoading?: boolean,
  isSlim?: boolean,
  size?: SelectSize,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
  ownProps: ValueContainerProps<SOption, IsMulti, Group>,
}

const ValueContainer = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  dataTest,
  isLoading,
  isSlim,
  size,
  components = {},
  ownProps,
}: IProps<SOption, IsMulti, Group>) => {
  const dataTestAttr = `${ dataTest }_value_container`;
  const style = useValueContainerStyles({ components, isLoading, isSlim, size, ownProps });
  const { children, ...otherProps } = ownProps;

  if (components?.ValueContainer) {
    const { ValueContainer: ValueContainerComponents } = components;

    return (
      <div data-test={ dataTestAttr } style={ style as React.CSSProperties }>
        <ValueContainerComponents { ...otherProps }>{ children }</ValueContainerComponents>
      </div>
    );
  }

  return (
    <div data-test={ dataTestAttr } style={ style as React.CSSProperties }>
      <ReactSelectComponents.ValueContainer { ...otherProps }>
        { children }
      </ReactSelectComponents.ValueContainer>
    </div>
  );
};

export default ValueContainer;
